module.exports = __webpack_public_path__ + "img/best_prices_icon.27bf6f9f.svg";